export default __webpack_public_path__ + "static/media/game-start-modal-marble.6af05619.png";